"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Yarn2LockParser = void 0;
const js_yaml_1 = require("js-yaml");
const yarnCore = require("@yarnpkg/core");
const debugModule = require("debug");
const lock_parser_base_1 = require("./lock-parser-base");
const _1 = require(".");
const config_1 = require("../config");
const errors_1 = require("../errors");
const yarn_utils_1 = require("./yarn-utils");
const debug = debugModule('snyk-nodejs-lockfile-parser:component-metadata');
class Yarn2LockParser extends lock_parser_base_1.LockParserBase {
    constructor() {
        super(_1.LockfileType.yarn2, config_1.config.YARN_TREE_SIZE_LIMIT);
    }
    parseLockFile(lockFileContents) {
        try {
            const rawYarnLock = (0, js_yaml_1.load)(lockFileContents, {
                json: true,
                schema: js_yaml_1.FAILSAFE_SCHEMA,
            });
            delete rawYarnLock.__metadata;
            const dependencies = {};
            const structUtils = yarnCore.structUtils;
            const parseDescriptor = structUtils.parseDescriptor;
            const parseRange = structUtils.parseRange;
            const keyNormalizer = (0, yarn_utils_1.yarnLockFileKeyNormalizer)(parseDescriptor, parseRange);
            Object.entries(rawYarnLock).forEach(([fullDescriptor, versionData]) => {
                keyNormalizer(fullDescriptor).forEach((descriptor) => {
                    dependencies[descriptor] = versionData;
                });
            });
            return {
                dependencies,
                lockfileType: _1.LockfileType.yarn2,
                object: dependencies,
                type: _1.LockfileType.yarn2,
            };
        }
        catch (e) {
            throw new errors_1.InvalidUserInputError(`yarn.lock parsing failed with an error: ${e.message}`);
        }
    }
    async getDependencyTree(manifestFile, lockfile, includeDev = false, strictOutOfSync = true, showNpmScope, includeComponentMetadata) {
        if (includeComponentMetadata) {
            // Berry lockfiles store no tarball URL and only a `checksum` over yarn's cache artifact
            // (not the published tarball SRI), so component-metadata labels are deferred for berry.
            debug('includeComponentMetadata is not yet supported for yarn berry (v2-4) lockfiles; ' +
                'no hash:* / distribution:url labels will be emitted');
        }
        const depTree = await super.getDependencyTree(manifestFile, lockfile, includeDev, strictOutOfSync, showNpmScope);
        const meta = { lockfileVersion: 2, packageManager: 'yarn' };
        const depTreeWithMeta = {
            ...depTree,
            meta: { ...depTree.meta, ...meta },
        };
        return depTreeWithMeta;
    }
    getDepMap(lockfile, resolutions, showNpmScope) {
        const yarnLockfile = lockfile;
        const depMap = {};
        const dependencies = lockfile.dependencies || {};
        for (const [depName, dep] of Object.entries(yarnLockfile.object)) {
            if (depName.endsWith('@workspace:.')) {
                continue;
            }
            const subDependencies = Object.entries({
                ...(dep.dependencies || {}),
                ...(dep.optionalDependencies || {}),
            }).map(([key, ver]) => findResolutions(dependencies, depName, key, resolutions) ||
                `${key}@${ver}`);
            depMap[depName] = {
                labels: {
                    scope: _1.Scope.prod,
                    ...(showNpmScope && { 'npm:scope': _1.Scope.prod }),
                },
                name: getName(depName),
                requires: subDependencies,
                version: dep.version,
            };
        }
        return depMap;
    }
    getDepTreeKey(dep) {
        return `${dep.name}@${dep.version}`;
    }
}
exports.Yarn2LockParser = Yarn2LockParser;
function getName(depName) {
    return depName.slice(0, depName.indexOf('@', 1));
}
function findResolutions(dependencies, depName, subDepKey, resolutions) {
    if (!resolutions)
        return;
    const resolutionKeys = Object.keys(resolutions);
    const index = depName.indexOf('@', 1);
    const name = depName.slice(0, index);
    const version = depName.slice(index + 1);
    const firstMatchingResolution = resolutionKeys.find((res) => {
        if (!res.endsWith(subDepKey)) {
            return false;
        }
        const leadingPkg = res.split(subDepKey)[0].slice(0, -1);
        const noSpecifiedParent = !leadingPkg;
        const specifiedParentMatchesCurrentDep = leadingPkg === name;
        const specifiedParentWithVersionMatches = leadingPkg.includes(name) &&
            leadingPkg.includes(dependencies[`${name}@${version}`].version);
        return (noSpecifiedParent ||
            specifiedParentMatchesCurrentDep ||
            specifiedParentWithVersionMatches);
    });
    if (resolutionKeys && firstMatchingResolution) {
        return `${subDepKey}@${resolutions[firstMatchingResolution]}`;
    }
}
//# sourceMappingURL=yarn2-lock-parser.js.map